var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494 483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Degradado_sin_nombre_1165);\n      }\n\n      .st1 {\n        fill: url(#Degradado_sin_nombre_116);\n      }\n\n      .st2 {\n        fill: url(#Degradado_sin_nombre_1161);\n      }\n\n      .st3 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .st4 {\n        fill: url(#Degradado_sin_nombre_1163);\n      }\n\n      .st5 {\n        fill: url(#Degradado_sin_nombre_1162);\n      }\n\n      .st6 {\n        opacity: .21;\n      }\n\n      .st7 {\n        fill: url(#Degradado_sin_nombre_788);\n        opacity: .13;\n      }\n\n      .st8 {\n        fill: url(#Degradado_sin_nombre_680);\n      }\n\n      .st9 {\n        display: none;\n      }\n\n      .st10 {\n        fill: url(#Degradado_sin_nombre_1164);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient);\n      }\n\n      .st12 {\n        fill: url(#Degradado_sin_nombre_517);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_116",
    "data-name": "Degradado sin nombre 116",
    cx: -156.67,
    cy: -188.26,
    fx: -156.67,
    fy: -188.26,
    r: 1008.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#061d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131218"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1161",
    "data-name": "Degradado sin nombre 116",
    cx: -156.67,
    cy: -188.26,
    fx: -156.67,
    fy: -188.26,
    r: 1008.34,
    xlinkHref: "#Degradado_sin_nombre_116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_517",
    "data-name": "Degradado sin nombre 517",
    x1: 2.2,
    y1: 394.31,
    x2: 493.08,
    y2: 87.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8bdafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5efcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157ef8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_788",
    "data-name": "Degradado sin nombre 788",
    x1: 192.25,
    y1: -27.27,
    x2: 366.26,
    y2: 345.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#00f7ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_680",
    "data-name": "Degradado sin nombre 680",
    x1: 335.72,
    y1: 831.25,
    x2: 370.36,
    y2: 864.7,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f7ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1162",
    "data-name": "Degradado sin nombre 116",
    cx: 430.43,
    cy: 777.71,
    fx: 430.43,
    fy: 777.71,
    r: 140.31,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    xlinkHref: "#Degradado_sin_nombre_116"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1163",
    "data-name": "Degradado sin nombre 116",
    cx: 413.04,
    cy: 799.31,
    fx: 413.04,
    fy: 799.31,
    r: 96.02,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    xlinkHref: "#Degradado_sin_nombre_116"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1164",
    "data-name": "Degradado sin nombre 116",
    cx: 413.04,
    cy: 799.31,
    fx: 413.04,
    fy: 799.31,
    r: 96.02,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    xlinkHref: "#Degradado_sin_nombre_116"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1165",
    "data-name": "Degradado sin nombre 116",
    cx: 430.43,
    cy: 777.71,
    fx: 430.43,
    fy: 777.71,
    r: 140.31,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    xlinkHref: "#Degradado_sin_nombre_116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 297.71,
    y1: 750.59,
    x2: 563.15,
    y2: 750.59,
    gradientTransform: "translate(-314.72 -435.18) rotate(-11.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 483
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 20.35,
    y: 13.65,
    width: 454.59,
    height: 454.59,
    rx: 87.63,
    ry: 87.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M474.94,89.04v303.81c0,41.46-33.92,75.38-75.39,75.38H95.73c-41.46,0-75.38-33.92-75.38-75.38V89.04C20.35,47.58,54.28,13.65,95.73,13.65h303.81c41.47,0,75.39,33.92,75.39,75.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M399.55,472.97H95.74c-44.18,0-80.12-35.94-80.12-80.12V89.04C15.62,44.86,51.56,8.92,95.74,8.92h303.81c44.18,0,80.12,35.94,80.12,80.12v303.81c0,44.18-35.94,80.12-80.12,80.12ZM95.74,18.39c-38.96,0-70.66,31.7-70.66,70.66v303.81c0,38.96,31.7,70.66,70.66,70.66h303.81c38.96,0,70.66-31.7,70.66-70.66V89.04c0-38.96-31.7-70.66-70.66-70.66H95.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M464.18,259.58V89.04c0-35.64-29-64.64-64.64-64.64H95.74c-35.61,0-64.59,28.95-64.64,64.55.7,40.76,38.24,99.68,93.44,146.65,68.96,58.67,153.51,90.42,237.77,90.43,15.96,0,31.9-1.14,47.74-3.45,30.85-4.5,54.12-31.59,54.12-63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M150.01,359.34l21.85-11.74,2.84,62.07,80.69-148.1-33.24,12.63.76-1.47c-25.8,21.69-51.47,49.96-72.9,86.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "154.4 293.46 154.34 294.37 153.69 304.07 155.21 281.35 154.4 293.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "158.62 230.23 159.56 216.13 159.58 215.7 155.21 281.35 157.42 248.16 158.62 230.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "153.05 313.72 153.69 304.07 150.01 359.34 150.33 354.53 153.05 313.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.82,212.09l-.24,3.61-.03.43-.94,14.1-1.19,17.93-2.21,33.19-1.51,22.72-.64,9.64-2.72,40.81-.32,4.81c21.43-36.64,47.1-64.91,72.9-86.6l2.11-4.09h0c2.6-4.75,5.93-9.06,9.87-12.78l.95-.9c31.66-23.89,68.61-40.37,107.4-47.83l10.87-2.09s-80.8-13.73-93.38-13.4c-12.57.33-100.9,20.44-100.9,20.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M345.71,75.33c-43.15,5.16-84.89,17.47-124.06,36.59-5.47,2.67-12.94,6.9-20.68,11.49-22.95,13.62-37.75,37.64-39.53,64.27l-1.68,25.24-.19,2.79-.03.43-.94,14.1-1.19,17.93-2.21,33.19-1.51,22.72-.64,9.64-2.72,40.81-.32,4.81c21.43-36.64,47.1-64.91,72.9-86.6,65.21-54.84,131.19-67.69,131.19-67.69l1.97-29.53c-4.05.83-8.31.98-12.66.31-18.23-2.82-31.43-19.44-30.06-37.83,1.51-20.16,19.37-34.93,39.32-32.79,2.46.26,4.84.77,7.11,1.5l.89-.31,2.21-33.11-17.17,2.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "294.09 112.62 290.42 112.54 290.32 118.33 293.99 118.37 294.09 112.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.42,102.31l-3.67-.16c-.09,1.93-.16,3.86-.21,5.79l3.67.11c.05-1.92.12-3.83.21-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.99,92.06l-3.66-.27c-.13,1.94-.26,3.87-.36,5.8l3.67.2c.1-1.91.22-3.82.35-5.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.28,143.61l-3.67.12c.04,1.93.16,3.86.23,5.78l3.67-.16c-.08-1.92-.19-3.83-.23-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.03,133.29l-3.67.06c0,1.93.08,3.86.12,5.79l3.67-.09c-.05-1.92-.12-3.83-.12-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.97,123.01h-3.67c-.01,1.92-.02,3.85.01,5.78l3.67-.03c-.03-1.92-.02-3.83-.01-5.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.15,174.54l-3.66.32c.14,1.92.34,3.85.54,5.76l3.65-.36c-.2-1.91-.4-3.81-.54-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.34,164.25l-3.66.25c.1,1.93.3,3.85.44,5.77l3.66-.29c-.14-1.91-.34-3.82-.44-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.72,153.99l-3.67.19c.08,1.93.23,3.85.34,5.78l3.66-.22c-.11-1.91-.26-3.83-.34-5.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "299.74 205.31 296.11 205.84 296.97 211.57 300.6 210.99 299.74 205.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "298.35 195.09 294.71 195.55 295.43 201.29 299.07 200.79 298.35 195.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.16,184.88l-3.65.39c.2,1.92.37,3.84.63,5.76l3.65-.43c-.26-1.9-.43-3.81-.63-5.72Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b685670d4e691ba934cbd51c0ca05ae4.svg";
export { ForwardRef as ReactComponent };